import { checkVersion } from "./checkAppVersion";

export interface UpdateStatus {
  needsUpdate: boolean;
  url?: string;
  notes?: string;
}

/**
 * Returns whether a store update is required, without showing any UI.
 * Used to render the blocking ForceUpdateScreen. Fails "open"
 * (needsUpdate: false) on any error so the app is never bricked.
 */
export const getUpdateStatus = async (): Promise<UpdateStatus> => {
  try {
    const version: any = await checkVersion();

    console.log("Current version:", version);

    const url: string | undefined = version?.url;
    const needsUpdate =
      !!version?.needsUpdate && typeof url === "string" && url.startsWith("http");

    return { needsUpdate, url, notes: version?.notes };
  } catch (error) {
    console.error("Error checking app version:", error);
    return { needsUpdate: false };
  }
};
